export default {
  pageName: 'AI Task Center',
  pageId: '25053',
  pagePath: '/opinion/AITaskCenter',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    // TAB切换
    SummaryType: {
      buttonId: '25053001',
    },
    // 点击报告标题进入预览页
    PreviewAnalysis: {
      buttonId: '25053002',
    },
    // 点击下载报告
    DownloadReport: {
      buttonId: '25053003',
    },
    // 点击删除
    Delete: {
      buttonId: '25053004',
    },
    // 点击停止
    Stop: {
      buttonId: '25053007',
    },
    // 点击修改例行设置
    EditRepeatSettings: {
      buttonId: '25053005',
    },
    // 点击查看例行设置详情
    RepeatDetailSetting: {
      buttonId: '25053006',
    },
  },
};
